import dayjs from 'dayjs';
import React, { JSX } from 'react';
import { PostType } from '@/@types/post';
import { CATEGORIES } from '../constants';
import Style from './Post.module.scss';

interface Props extends Pick<PostType, 'url' | 'date' | 'title'> {
  eventType: PostType[keyof Pick<PostType, 'type'>];
}

const Post: React.FC<Props> = ({ url, date, eventType, title }): JSX.Element => {
  const convertUnixTimeToDate = (unixtime: number): string => {
    return dayjs(new Date(unixtime * 1000)).format('YYYY/MM/DD');
  };

  const removeBrackets = (str: string): string => {
    return str.replace(/^\[.*?\]/, '');
  };

  return (
    <article className={Style.post}>
      <div className={Style.date}>{convertUnixTimeToDate(+date)}</div>
      <div className={Style.category}>
        <span className={Style.label} data-category={eventType}>
          {CATEGORIES[eventType]}
        </span>
      </div>
      <a className={Style.link} href={url} target="_blank" rel="noreferrer">
        <h3 className={Style.title}>{removeBrackets(title)}</h3>
      </a>
    </article>
  );
};

export default Post;
